import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpService } from './http.service';
import { IUserInfo } from '../shared/interfaces/IUser';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private httpService: HttpService) { }

  getUsers(params: any): Observable<any[]> {
    return this.httpService.get("user", { params })
  }

  getUser(id: number): Observable<any> {
    return this.httpService.get(`user/${id}`);
  }

  updateUserInfo(payload: IUserInfo): Observable<number> {
    return this.addOrUpdateUser(payload);
  }

  addOrUpdateUser(payload: any, redirectUrl?: string): Observable<number> {
    let params: HttpParams | undefined;
    if (redirectUrl) {
      params = new HttpParams().set('redirectUrl', redirectUrl);
    }
    return this.httpService.post('user', payload, params ? { params } : undefined);
  }

  deleteUser(id: number) {
    return this.httpService.delete(`user/${id}`);
  }
}
